import { track, trackingEvents } from 'modules/core/lib/Tracking'

export const trackOpenBenefitsSettingsPage = (source: string) => {
  track(trackingEvents.benefits.openBenefitsSettingsPage, {
    source,
  })
}

export const trackClickSaveResetDay = (currentDay: number, newDay: number) => {
  track(trackingEvents.benefits.clickSaveResetDay, {
    current_reset_day: currentDay,
    new_reset_day: newDay,
  })
}

export const trackConfirmResetDayChange = (currentDay: number, newDay: number) => {
  track(trackingEvents.benefits.confirmResetDayChange, {
    current_reset_day: currentDay,
    new_reset_day: newDay,
  })
}

export const trackCancelResetDayChange = () => {
  track(trackingEvents.benefits.cancelResetDayChange)
}
